import { createAction, props } from '@ngrx/store';

import {
  IAuthApiErrorModel,
  IConfirmSignUpInfoModel,
  IForgotPasswordCodeInitModel,
  IForgotPasswordResetModel,
  ILoginInfoModel,
  IResetPasswordModel,
  ISignUpInfoModel,
  ISignUpResultModel,
  IUserCognitoInfoModel,
} from '@features/auth-amplify/models';

export const loginInitiated = createAction('[Login Page] Login initiated', props<{ payload: ILoginInfoModel }>());

export const loginSuccess = createAction('[Auth Api] Login success', props<{ payload: IUserCognitoInfoModel }>());

export const loginFailed = createAction('[Auth Api] Login failed', props<{ payload: IAuthApiErrorModel }>());

export const signUpInitiated = createAction('[Sign up Page] Signup initiated', props<{ payload: ISignUpInfoModel }>());

export const signUpSuccess = createAction('[Auth Api] Signup success', props<{ payload: ISignUpResultModel }>());

export const signUpFailed = createAction('[Auth Api] Signup failed', props<{ payload: IAuthApiErrorModel }>());

export const confirmEmailInitiated = createAction(
  '[Email confirm Page] Confirm email initiated',
  props<{ payload: IConfirmSignUpInfoModel }>()
);

export const confirmEmailSuccess = createAction('[Email confirm Page] Confirm email success');

export const confirmEmailFailed = createAction(
  '[Email confirm Page] Confirm email failed',
  props<{ payload: IAuthApiErrorModel }>()
);

export const forgotPasswordCodeInitiated = createAction(
  '[Sign up Page] Forgot password request code initiated',
  props<{ payload: IForgotPasswordCodeInitModel }>()
);

export const forgotPasswordCodeSuccess = createAction(
  '[Auth Api] Forgot password request code success',
  props<{ payload: IForgotPasswordCodeInitModel }>()
);

export const forgotPasswordCodeFailed = createAction(
  '[Auth Api] Forgot password request code failed',
  props<{ payload: IAuthApiErrorModel }>()
);

export const forgotPasswordResetInitiated = createAction(
  '[Sign up Page] Forgot password reset password initiated',
  props<{ payload: IForgotPasswordResetModel }>()
);

export const forgotPasswordResetSuccess = createAction('[Auth Api] Forgot password reset password success');

export const forgotPasswordResetFailed = createAction(
  '[Auth Api] Forgot password reset password failed',
  props<{ payload: IAuthApiErrorModel }>()
);

export const resetPasswordInitiated = createAction(
  '[Sign up Page] Reset password initiated',
  props<{ payload: IResetPasswordModel }>()
);

export const resetPasswordSuccess = createAction('[Auth Api] Reset password success');

export const resetPasswordFailed = createAction(
  '[Auth Api] Reset password failed',
  props<{ payload: IAuthApiErrorModel }>()
);

export const confirmEmailResendCodeInitiated = createAction(
  '[Email confirm Page] Confirm email code resend initiated',
  props<{ payload: string }>()
);

export const confirmEmailResendCodeSuccess = createAction(
  '[Email confirm Page] Confirm email code resend initiated success'
);

export const confirmEmailResendCodeFailed = createAction(
  '[Email confirm Page] Confirm email code resend initiated failed',
  props<{ payload: IAuthApiErrorModel }>()
);

export const AuthAmplifyActions = {
  loginInitiated,
  loginSuccess,
  loginFailed,
  sessionRehydrateInitiated: createAction('[Auth Amplify] Session rehydrate initiated'),
  sessionRehydrateSuccess: createAction(
    '[Auth Amplify] Session rehydrate success',
    props<{ payload: IUserCognitoInfoModel }>()
  ),
  sessionRehydrateFailed: createAction('[Auth Amplify] Session rehydrate failed', props<{ payload: any }>()),
  signUpInitiated,
  signUpSuccess,
  signUpFailed,
  confirmEmailInitiated,
  confirmEmailSuccess,
  confirmEmailFailed,
  forgotPasswordCodeInitiated,
  forgotPasswordCodeSuccess,
  forgotPasswordCodeFailed,
  forgotPasswordResetInitiated,
  forgotPasswordResetSuccess,
  forgotPasswordResetFailed,
  resetPasswordInitiated,
  resetPasswordSuccess,
  resetPasswordFailed,
  confirmEmailResendCodeInitiated,
  confirmEmailResendCodeSuccess,
  confirmEmailResendCodeFailed,
};
